import { API } from "aws-amplify";
import { listLeases } from "~/graphql/queries";
import { FilterValue, GRAPHQLFilters, LoaderData } from "~/types";
import { getGraphqlFilters } from "~/utils";
import * as APITypes from "~/API";

export const getLeaseList = async ({
  tenantID,
  entityType,
  entityID,
  ownerID,
  ownerType,
  status,
  startDate,
  endDate,
  nextLeaseID,
  includeDeleted = "exclude",
}: {
  tenantID?: string;
  entityType?: APITypes.EntityType;
  entityID?: string;
  ownerID?: string;
  ownerType?: APITypes.OwnerType;
  status?: APITypes.LeaseStatusType;
  startDate?: FilterValue;
  endDate?: FilterValue;
  nextLeaseID?: string;
  includeDeleted?: "all" | "exclude" | "only";
}): Promise<LoaderData<APITypes.Lease[]>> => {
  let filters: GRAPHQLFilters = getGraphqlFilters({
    tenantID,
    entityType,
    entityID,
    ownerID,
    ownerType,
    status,
    startDate,
    endDate,
    nextLeaseID,
  });

  // Add _deleted filter based on includeDeleted parameter
  if (includeDeleted === "exclude") {
    filters._deleted = { ne: true };
  } else if (includeDeleted === "only") {
    filters._deleted = { eq: true };
  }
  // If includeDeleted === "all", don't add any _deleted filter

  let items: APITypes.Lease[] = [];
  let nextToken: string | null | undefined = undefined;
  try {
    do {
      let response = (await API.graphql({
        query: listLeases,
        variables: {
          filter: filters,
          nextToken,
        },
      })) as { data?: APITypes.ListLeasesQuery };

      const allLeases =
        response.data?.listLeases?.items?.filter(
          (item): item is APITypes.Lease => item !== null
        ) ?? [];
      items.push(...allLeases);
      nextToken = response.data?.listLeases?.nextToken;
    } while (nextToken);

    return {
      success: true,
      data: items,
    };
  } catch (error) {
    console.error("Error getting lease list", error);
    return {
      success: false,
      data: [],
      error,
    };
  }
};
